<template>
    <div class="page-scan-in">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">同城配送</div>
            <div class="breadcrumb-item">同城本地入件</div>
        </div>

        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Row>
                    <Col>
                        <Form :label-width="180">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>收件人手機號/會員號</span>
                                </div>
                                <Input prefix="ios-call" ref='recipient_phone' v-model="form.recipient_phone" @on-blur="getPickAddressByPhone" style="border: 2px solid;border-radius: 5px;" :maxlength="8"></Input>
                                <!-- <span style="color:red">若已註冊集運幫輸入可獲得會員名稱、提貨櫃點和收件方式</span> -->
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>收件人</span>
                                </div>
                                <Input prefix="ios-contact" v-model="form.recipient_contacts" style="border: 2px solid;border-radius: 5px;"></Input>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>提貨櫃點</span>
                                </div>

                                <Select prefix="ios-pin" placeholder="" not-found-text="無匹配數據" filterable v-model="form.arrive"
                                        @on-change="handleArriveSelect" style="border: 2px solid;border-radius: 5px;">
                                    <Option :value="item.ReceivingID" v-for="(item, index) in pickAddress"
                                            :key="item.ReceivingID">({{item.cainiao_match}}) {{item.ReceivingName}}
                                    </Option>
                                </Select>
                            </FormItem>

                            <FormItem hidden>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>店/櫃</span>
                                </div>

                                <RadioGroup v-model="form.arrive_type">
                                    <Radio :disabled="arrive_type_status ? true : false" :label="1">
                                        <span>門店</span>
                                    </Radio>
                                    <Radio :disabled="arrive_type_status ? true : false" :label="2">
                                        <span>智能櫃</span>
                                    </Radio>
                                </RadioGroup>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>出貨單號</span>
                                </div>

                                <Input prefix="md-cube" v-model="form.odd_numbers" @on-blur="getOdd" @keyup.enter.native="getOdd" placeholder="最多25個字" style="border: 2px solid;border-radius: 5px;" :maxlength="25">
                                </Input>

                                <!-- <span style="color:red">{{form.odd_numbers}}</span> -->

                                <!-- <span style="color:red">XXXXXXX為隨機數字，主要是防止單號重覆的問題</span> -->
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>包裹重量</span>
                                </div>
                                <InputNumber :min="1" v-model="form.weight" placeholder="KG" style="border: 2px solid;border-radius: 5px;width:100%"></InputNumber>
                                &nbsp;
                                <!-- <span style="color:red">請輸入整數</span> -->
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <span>代收金額</span>
                                </div>
                                <InputNumber :min="0" v-model="form.freight_collect" placeholder="MOP費用" style="border: 2px solid;border-radius: 5px;width:100%"></InputNumber>
                                <!-- &nbsp; -->
                                <!-- <span style="color:red">為空就代表不用出客戶到付費用</span> -->
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <span>貨物描述</span>
                                </div>
                                <Input prefix="ios-bookmarks" :maxlength="15" v-model="form.remarks" placeholder="最多15個字" style="border: 2px solid;border-radius: 5px;"></Input>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <!-- <span>付費方式</span> -->
                                </div>
                                <RadioGroup v-model="form.type">
                                    <Radio :label="1">
                                        <span>收方付費</span>
                                    </Radio>
                                    <Radio :label="2" v-if="form.freight_collect == 0">
                                        <span>商家餘額</span>
                                    </Radio>
                                    <Radio :label="3" v-if="form.freight_collect == 0">
                                        <span>商家月結</span>
                                    </Radio>
                                </RadioGroup>
                            </FormItem>

                            <FormItem>
                                    <div class="pg-btn-wrap">
                                    <div class="pg-btn style1" @click="handleCheckForm">入庫並打印</div>
                                    <!-- <div class="pg-btn style1" @click="handlePrintCode">同城入庫</div> -->
                                    </div>
                            </FormItem>

                            <FormItem>
                                <span style="color:red;font-size: 26px;">商家餘額：{{sc_balance}}</span>
                            </FormItem>

                        </Form>
                    </Col>

                    <!-- <Col span="10" offset="1">
                        <Form :label-width="160">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <span>寄件人名稱（選填）</span>
                                </div>
                                <Input v-model="form.courier" style="border: 2px solid;border-radius: 5px;"></Input>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <span>寄件人電話（選填）</span>
                                </div>
                                <Input v-model="form.courier_tel" type="number" :min="0" style="border: 2px solid;border-radius: 5px;"></Input>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <span>備註（選填）</span>
                                </div>
                                <Input :maxlength="50" type="textarea" v-model="form.remarks" placeholder="最多輸入50個字" style="border: 2px solid;border-radius: 5px;"></Input>
                            </FormItem>

                            <FormItem>
                                <span style="color:red;font-size: 26px;">商家餘額：{{sc_balance}}</span>
                            </FormItem>
                        </Form>
                    </Col> -->
                </Row>
            </div>
        </div>
        <!-- <iframe style="display:none" id="printIframe" src="<%=data%>"></iframe>-->
        <iframe id="printIframe" style="display:none" :src="pdfUrl"></iframe>
    </div>
</template>

<script>
    import md5 from 'js-md5';
    export default {
        data()
        {
            return {
                // deliverListAll: [], //所有快件明細
                // deliverList: [],    //快件明細，截取
                pickAddress: [],    //提貨櫃點
                packageType: [],    //包裹類型
                deliverExc: [], //異常件
				err_audio: "https://jyb-admin-backend.aoyunltd.com/audio/music-fail.mp3",
				suc_audio: "https://jyb-admin-backend.aoyunltd.com/audio/music-success.mp3",
                isLoadingDeliver: false,
				arrive_type_status: false,
                form: {
                    goods_type: 2,  //包裹類型ID
                    count: 1, //數量
                    weight: 1, //重量單位
                    odd_numbers: '', //單號
                    recipient_phone: '', //澳門手機號
                    recipient_contacts: '', //澳門客戶名稱
                    detailed: 3648, //快件明細
                    arrive: '', //提貨櫃點
                    arrive_type: '', //收件方式: 1門店，2:智能櫃
                    abnormal_id: '', //異常ID
                    freight_collect: 0, //珠海到付運費
                    type: '', //快遞類型
                    courier: '',
                    courier_tel: '',
                    remarks: '',
                },
                isSubmiting: false,
                pdfUrl: '',
                sc_name: '',
                sc_id: '',
                sc_user_id: '',
                sc_store_id: '',
                sc_balance: '',
                confirm: 0,
                // current_time: '',
                // random_number: '',
            };
        },
        created(){
            // this.getDeliverList();
            this.getPickAddress();
            let logInfo = localStorage.getItem('jyb_logInfo') ? JSON.parse(localStorage.getItem('jyb_logInfo')) : {};
            let token = localStorage.getItem('jyb_token') || '';
            const state = {
                logInfo,
                token
            };
            if(state.logInfo.userparent != null){
                this.sc_name = state.logInfo.userparent.mark;
                this.sc_id = state.logInfo.userparent.id;
                this.sc_balance = state.logInfo.userparent.balance;
                this.sc_user_id = state.logInfo.user_id;
                this.sc_store_id = state.logInfo.store_id;
            }
        },
        mounted()
        {
            
            // let random_run = this.random(1000,9999);
            // this.random_number = random_run;
            // var data = new Date();
            // var month = data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
            // var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
            // let current_md5 = md5((data.getYear() - 100) + "" + month + "" + date + random_run);
            // this.current_time = (current_md5.substr(current_md5.length-4));
            // this.current_time = data.getFullYear() + "" + month + "" + date; 
            // this.getPackageType();
            // this.getDeliverExc();
        },
        methods: {
			getOdd() {
				if(this.odd_numbers == '') {
					return false;
				}
				this.getItem();
			},
			getItem() {
			    this.$Rq.requestAuth({
			        url: this.$Api.scanIn,
			        method: 'get',
			        data: {
						sack_number: this.form.odd_numbers,
			            odd_numbers: this.form.odd_numbers,
			        }
			    }).then((res) => {
					if(res.data.count == 1) {
						this.$Utils.showTipInfo('出貨單號已存在');
                        this.confirm = 1;
						let audio = new Audio()
						audio.src = this.err_audio
						audio.play();
					}else{
                        this.confirm = 0;
                    }
			    })
			},
            //快件明細
            // getDeliverList()
            // {
            //     this.$Rq.requestAuth({
            //         url: this.$Api.deliverList,
            //         method: 'get',
            //         data: {
            //             /* offset: 0,
            //              limit: 200,
            //              keywords: ''*/
            //         }
            //     }).then((res) =>
            //     {
            //         if (res.code == 0)
            //         {
            //             let resData = res.data.data;
            //             this.deliverListAll = resData;
            //             this.deliverList = resData.slice(0, 240);
            //         }
            //     });
            // },
            //提貨櫃點
            getPickAddress()
            {
                this.$Rq.requestAuth({
                    url: this.$Api.pickAddress,
                    method: 'get',
                    data: {
                        company_id: 1,
                    }
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.pickAddress = res.data.data;
                    }
                });
            },
            //根據手機號獲取提貨櫃點,以及客戶名稱
            getPickAddressByPhone()
            {
                let form = this.form;
                if (form.recipient_phone !== '') {

                    this.$Rq.requestAuth({
                        url: this.$Api.getInfoByPhone + "/" + form.recipient_phone,
                        method: 'get',
                    }).then((res) => {
                        if (res.code == 0) {
							if(res.data.length==0) {
								this.$Utils.showTipInfo('用戶不存在');
								// return false;
							}
                            else {
                                let resData = res.data || {};
                                this.form.recipient_contacts = resData.user_id ? resData.user_name : '';
                                this.form.recipient_phone = resData.user_id ? resData.phone : ''; // 會員號碼 match 電話號碼
                                this.form.arrive = resData.receiving ? resData.receiving.ReceivingID : '';
                                this.form.arrive_type = resData.receiving ? resData.receiving.Type : '';    //type 1门店， 2是智能柜
                            }
                        }
                    });
                }
                else {
                    this.form.recipient_contacts = '';
                    this.form.arrive = '';
                }
            },
            //提貨櫃點選擇
            handleArriveSelect(value)
            {
                if (value == undefined) {
					this.arrive_type_status = false;
					return;
				}
                let pickAddress = this.pickAddress;
                let index = null;
                for (let i = 0; i < pickAddress.length; i++)
                {
                    if (value == pickAddress[i].ReceivingID)
                    {
                        index = i;
                        break;
                    }
                }
				this.arrive_type_status = true;
                this.form.arrive_type = pickAddress[index].Type; //Type 1門店, 2智能櫃	
            },
            //提交
            handleCheckForm()
            {
                let form = this.form;
                let reg = /^(853)?6\d{7}$/;

                if (form.recipient_phone == '')
                {
                    this.$Utils.showTipInfo('請輸入收件人手機號/會員號');
                    return;
                }
                if (form.recipient_phone.length == 8){
                    if(!reg.test(form.recipient_phone)){
                        this.$Utils.showTipInfo('必須為澳門手機號碼格式');
                        return;
                    }
                }
                if (form.recipient_contacts == '')
                {
                    this.$Utils.showTipInfo('請輸入收件人');
                    return;
                }
                if (form.arrive == '')
                {
                    this.$Utils.showTipInfo('請選擇提貨櫃點');
                    return;
                }
                if (form.odd_numbers == '')
                {
                    this.$Utils.showTipInfo('請輸入出貨單號');
                    return;
                } 
                if (form.odd_numbers.length < 11)
                {
                    this.$Utils.showTipInfo('出貨單號長度必須超過10個字');
                    return;
                } 
                if (form.weight == '')
                {
                    this.$Utils.showTipInfo('請輸入包裹重量');
                    return;
                }
                if (form.type == '')
                {
                    this.$Utils.showTipInfo('請選擇收費方式');
                    return;
                }
                if (!(form.detailed > 0))
                {
                    this.$Utils.showTipInfo('請選擇同城明細');
                    return;
                }		
                if (form.arrive_type == '')
                {
                    this.$Utils.showTipInfo('請選擇收件方式');
                    return;
                } 
                if (form.type == 2 && form.freight_collect > 0)
                {
                    this.$Utils.showTipInfo('選擇商家餘額，代收金額要輸入0元');
                    return;
                } 
                if (form.type == 3 && form.freight_collect > 0)
                {
                    this.$Utils.showTipInfo('選擇商家月結，代收金額要輸入0元');
                    return;
                }

                if(this.confirm == 1){
                    this.$Utils.showTipInfo('出貨單號已存在');
                    let audio = new Audio()
                    audio.src = this.err_audio
                    audio.play();
                    form.odd_numbers = "";
                    return;
                }

                this.handleSubmit();
				this.$refs.recipient_phone.focus();
            },
            
            random(lower, upper) {
                return Math.floor(Math.random() * (upper - lower+1)) + lower;
            },

            handleSubmit()
            {
                let form = this.form;
                this.isSubmiting = true;

                this.$Rq.requestAuth({
                    url: this.$Api.samecityListAdd,
                    method: 'post',
                    data: {
                        recipient_phone: form.recipient_phone,
                        recipient_contacts: form.recipient_contacts,
                        odd_numbers: form.odd_numbers,
                        arrive_type: Number(form.arrive_type) ? Number(form.arrive_type): 1,
                        detailed: Number(form.detailed),
                        weight: Number(form.weight),
                        long: 0,
                        wide: 0,
                        height: 0,
                        arrive: Number(form.arrive),
                        goods_type: Number(form.goods_type),
                        type: Number(form.type),
                        freight_collect: Number(form.freight_collect) ? Number(form.freight_collect) : 0,
                        courier: form.courier,
                        courier_tel: Number(form.courier_tel),
                        remarks: form.remarks
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;

                    if (res.code == 0)
                    {
						if(res.msg == "入庫成功") {
							let audio = new Audio()
							audio.src = this.suc_audio
							audio.play();
                            this.handlePrintCode();
						} else {
							let audio = new Audio()
							audio.src = this.err_audio
							audio.play();
						}
						
                        this.$Utils.showSuccess(res.msg);
                        // this.deliverList = this.deliverListAll.slice(0, 240);
                        // this.random_number = this.random(1000,9999);
                        this.form = {
                            count: 1,   //數量
                            weight: 1,  //重量單位g
                            odd_numbers: '',  //單號
                            recipient_phone: '',  //澳門手機號
                            long: 0,    //長
                            wide: 0,    //寬
                            height: 0,   //高
                            size: 0, //尺寸，1: 最長邊大於50cm; 2: 小於5cm
                            detailed: Number(form.detailed),    //快件明細id
                            recipient_contacts: '',  //澳門客戶名稱
                            arrive: '', //提貨櫃點
                            goods_type: 2,  //包裹類型id
                            type: '',
                            arrive_type: '',   //收件方式: 1門店，2:智能櫃
                            abnormal_id: '', //異常id
                            freight_collect: 0, //珠海到付運費
                            courier: '',
                            courier_tel: '',
                            remarks: ''
                        };
                    } else {
						let audio = new Audio()
						audio.src = this.err_audio
						audio.play();
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) =>
                {
					let audio = new Audio()
					audio.src = this.err_audio
					audio.play();
                    this.isSubmiting = false;
                });
            },

            //打印條碼
            handlePrintCode()
            {
                let form = this.form;
                if (form.recipient_phone == '')
                {
                    this.$Utils.showTipInfo('請輸入收件人手機號/會員號');
                    return;
                }
                if (form.recipient_contacts == '')
                {
                    this.$Utils.showTipInfo('請輸入收件人');
                    return;
                }
                if (form.arrive == '')
                {
                    this.$Utils.showTipInfo('請選擇提貨櫃點');
                    return;
                }
                if (form.odd_numbers == '')
                {
                    this.$Utils.showTipInfo('請輸入出貨單號');
                    return;
                } 
                if (form.weight == '')
                {
                    this.$Utils.showTipInfo('請輸入包裹重量');
                    return;
                }
                if (form.type == '')
                {
                    this.$Utils.showTipInfo('請選擇收費方式');
                    return;
                }
                // if (!(form.detailed > 0))
                // {
                //     this.$Utils.showTipInfo('請選擇同城明細');
                //     return;
                // }       
                if (form.arrive_type == '')
                {
                    this.$Utils.showTipInfo('請選擇收件方式');
                    return;
                } 
                if (form.type == 2 && form.freight_collect > 0)
                {
                    this.$Utils.showTipInfo('選擇商家餘額，代收金額要輸入0元');
                    return;
                } 
                if (form.type == 3 && form.freight_collect > 0)
                {
                    this.$Utils.showTipInfo('選擇商家月結，代收金額要輸入0元');
                    return;
                }
                let token = localStorage.getItem('jyb_token');
                let params = {
                    type: form.type,
                    arrive: form.arrive,
                    weight: form.weight,
                    courier: form.courier,
                    courier_tel: form.courier_tel,
                    odd_numbers: form.odd_numbers,
                    recipient_contacts: form.recipient_contacts,
                    recipient_phone: form.recipient_phone,
                    remarks: form.remarks,
                    freight_collect: Number(form.freight_collect) ? Number(form.freight_collect): 0,
                    parent_id: this.sc_id,
                    store_id: this.sc_store_id,
                    user_id: this.sc_user_id,
                };
                this.pdfUrl = this.$Api.samecityorderprint + '?' + this.$Utils.formateObjToParamStr(params);
                window.open(this.pdfUrl);
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "samecityScanin.scss";
</style>